import "@/App.css";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import HomeDashboardPage from "@/pages/HomeDashboardPage";
import StudioPage from "@/pages/StudioPage";
import ListingPage from "@/pages/ListingPage";
import ReviewPage from "@/pages/ReviewPage";
import AutomationPage from "@/pages/AutomationPage";
import ContentPage from "@/pages/ContentPage";
import AffiliatePage from "@/pages/AffiliatePage";
import ColoringPage from "@/pages/ColoringPage";
import SiteLayout from "@/components/site/SiteLayout";
import HomePage from "@/pages/site/HomePage";
import ShopPage from "@/pages/site/ShopPage";
import ProductPage from "@/pages/site/ProductPage";
import OrderPage from "@/pages/site/OrderPage";
import BlogPage from "@/pages/site/BlogPage";
import PostPage from "@/pages/site/PostPage";
import AboutPage from "@/pages/site/AboutPage";
import FreePrintablePage from "@/pages/site/FreePrintablePage";
import SectionPage from "@/pages/site/SectionPage";
import { GuidePage, GuidesIndexPage } from "@/pages/site/GuidePages";
import GalleryPage from "@/pages/site/GalleryPage";
import GiftFinderPage from "@/pages/site/GiftFinderPage";
import PhotosPage from "@/pages/PhotosPage";
import PinsPage from "@/pages/PinsPage";
import SeasonsPage from "@/pages/SeasonsPage";
import ImagesPage from "@/pages/ImagesPage";

function Protected() {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 font-display font-bold text-[#23324A]" data-testid="auth-loading">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;
  return <AppShell />;
}

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/shop/:id" element={<ProductPage />} />
            <Route path="/order/:token" element={<OrderPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/free-printable" element={<FreePrintablePage />} />
            <Route path="/gifts/:section" element={<SectionPage />} />
            <Route path="/guides" element={<GuidesIndexPage />} />
            <Route path="/guides/:slug" element={<GuidePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gift-finder" element={<GiftFinderPage />} />
            <Route path="/:slug" element={<PostPage />} />
          </Route>
          <Route element={<AuthProvider><Outlet /></AuthProvider>}>
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin" element={<Protected />}>
              <Route index element={<HomeDashboardPage />} />
              <Route path="listings" element={<DashboardPage />} />
              <Route path="studio" element={<StudioPage />} />
              <Route path="review" element={<ReviewPage />} />
              <Route path="automation" element={<AutomationPage />} />
              <Route path="articles" element={<ContentPage />} />
              <Route path="affiliate" element={<AffiliatePage />} />
              <Route path="coloring" element={<ColoringPage />} />
              <Route path="photos" element={<PhotosPage />} />
              <Route path="images" element={<ImagesPage />} />
              <Route path="pins" element={<PinsPage />} />
              <Route path="seasons" element={<SeasonsPage />} />
              <Route path="listings/:id" element={<ListingPage />} />
            </Route>
          </Route>
          <Route path="/login" element={<Navigate to="/admin/login" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { fontFamily: "Inter, sans-serif", border: "2px solid #23324A", borderRadius: 16 } }} />
    </>
  );
}
